import {clientIntl} from '../../../../../shared/scripts/ClientI18n'
import {UIMMenuGameOrientationController} from './UIMMenuGameOrientationController'
import {setElementOnClick} from '../../../../../shared/scripts/ui_utils/DomUtils'
import {uiManager} from '../../../EntryMobile'
import {StorageWrapper} from '../../../../../shared/scripts/StorageWrapper'
import {navigateToPage} from '../../../../../shared/scripts/ui_utils/ClientUtils'
import {UILanguageButtonController} from '../../../../../shared/scripts/ui_popup/ui_language/UILanguageButtonController'

enum MenuState {
    OPEN,
    CLOSED
}
export class UIMHeaderHamburgerController {
    private readonly hamburger: HTMLElement
    private readonly overlayScreen: HTMLElement
    private readonly menu: HTMLDivElement
    private readonly closeButton: HTMLElement
    private readonly rulebookButton: HTMLLinkElement

    private menuState: MenuState

    constructor() {
        this.menu = document.getElementById('m-mainpage-menu') as HTMLDivElement
        this.hamburger = document.getElementById('header-element-hamburger-container') as HTMLElement
        this.closeButton = document.getElementById('m-mainpage-menu-close') as HTMLElement
        this.overlayScreen = document.getElementById('m-mainpage-overlay') as HTMLElement
        this.rulebookButton = document.getElementById('m-mainpage-menu-link-rulebook') as HTMLLinkElement
        new UIMMenuGameOrientationController()
        new UILanguageButtonController(this.menu)

        setElementOnClick(this.rulebookButton, () => {
            const currentScene = uiManager.sceneController.scene
            StorageWrapper.setLastScene(currentScene)
            navigateToPage(`${clientIntl.getLanguagePathPrefix()}/catan-rules?style=mobile`, false, true)
        })

        this.setOpenAndCloseAction()
    }

    private setOpenAndCloseAction() {
        setElementOnClick(this.hamburger, () => this.setOpenAction())
        setElementOnClick(this.closeButton, () => this.setCloseAction())
        setElementOnClick(this.overlayScreen, () => this.setCloseAction())
    }

    private setOpenAction() {
        if(this.menuState == MenuState.OPEN) return
        this.menu.classList.add('open')
        this.overlayScreen.classList.remove('hidden')
        this.menuState = MenuState.OPEN
    }

    setCloseAction() {
        if(this.menuState == MenuState.CLOSED) return
        this.menu.classList.remove('open')
        this.overlayScreen.classList.add('hidden')
        this.menuState = MenuState.CLOSED
    }

    hide() {
        this.menu.style.display = 'none'
    }

    show() {
        this.menu.style.display = ''
    }
}
